import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import useLocalStorage from "use-local-storage";
import Analysis from "./Pages/Analysis/Analysis";
import AllBusiness from "./Pages/Business/AllBusiness";
import Business from "./Pages/Business/Business";
import AllContractors from "./Pages/Contractors/AllContractors";
import Contractors from "./Pages/Contractors/Contractors";
import CreateContractor from "./Pages/Contractors/CreateContractor";
import EditContractor from "./Pages/Contractors/EditContractor";
import Dashboard from "./Pages/Dashboard/Dashboard";
import AllDesigners from "./Pages/Designers/AllDesigners";
import CreateDesigner from "./Pages/Designers/CreateDesigner";
import Designers from "./Pages/Designers/Designers";
import EditDesigner from "./Pages/Designers/EditDesigner";
import SendMail from "./Pages/Emails/SendMail";
import CreateMail from "./Pages/Emails/CreateMail";
import AllInstallers from "./Pages/Installer/AllInstallers";
import Installers from "./Pages/Installer/Installers";
import SingleInstaler from "./Pages/Installer/SingleInstaler";
import AllLeads from "./Pages/Leads/AllLeads";
import EditLead from "./Pages/Leads/EditLead";
import LeadInfo from "./Pages/Leads/LeadInfo";
import Leads from "./Pages/Leads/Leads";
import Login from "./Pages/Login/Login";
import NotFound from "./Pages/NotFound/NotFound";
import EditPanel from "./Pages/Panels/EditPanel";
import Panels from "./Pages/Panels/Panels";
import PanelsDataGrid from "./Pages/Panels/PanelsDataGrid";
import AllUsers from "./Pages/Users/AllUsers";
import EditUsers from "./Pages/Users/EditUsers";
import Users from "./Pages/Users/Users";
import AllUtility from "./Pages/UtilityProviders/AllUtility";
import EditUtility from "./Pages/UtilityProviders/EditUtility";
import UtilityProviders from "./Pages/UtilityProviders/UtilityProviders";
import AllVendors from "./Pages/Vendors/AllVendors";
import CreateVendor from "./Pages/Vendors/CreateVendor";
import EditVendor from "./Pages/Vendors/EditVendor";
import Vendors from "./Pages/Vendors/Vendors";
// import EditUser from "./Pages/Users/EditUser";
import { GlobalStyle } from "./Styles/GlobaalStyled";
import AllLicense from "./Pages/Designers/DesignerLicense/AllLicense";
import CreateLicense from "./Pages/Designers/DesignerLicense/Createlicense";
import Solutions from "./Pages/Solutions/Solutions";
import AllSolution from "./Pages/Solutions/AllSolution";
import EverSignDocuments from "./Pages/EverSignDocuments/EverSignDocuments";
import AllDocuments from "./Pages/EverSignDocuments/AllDocuments";
import Adders from "./Pages/Adders/Adders";
import Addersv2 from "./Pages/Addersv2/Addersv2";
import AllAdders from "./Pages/Adders/AllAdders";
import AllAddersCategories from "./Pages/AddersCategories/AllAddersCategories";
import CreateAdderCategory from "./Pages/AddersCategories/CreateAdderCategory";
import EditAdderCategory from "./Pages/AddersCategories/EditAdderCategory";
import GroupChildrens from "./Pages/AddersCategories/GroupChildrens";
import AddersCategories from "./Pages/AddersCategories/AddersCategories";
import AllAddersv2 from "./Pages/Addersv2/AllAddersv2";
import CreateAdder from "./Pages/Adders/CreateAdder";
import CreateAdderv2 from "./Pages/Addersv2/CreateAdderv2";
import EditAdder from "./Pages/Adders/EditAdder";
import EditAdderv2 from "./Pages/Addersv2/EditAdderv2";
import CreateAdderv2Child from "./Pages/Addersv2/CreateAdderv2Child";
import AllAddersv2Childs from "./Pages/Addersv2/AllAddersv2Childs";
import CreateInstaller from "./Pages/Installer/CreateInstaller";
import SolarContract from "./Pages/SolarContract/SolarContract";
import AllSolarContracts from "./Pages/SolarContract/AllSolarContracts";
import ShowSolarContract from "./Pages/SolarContract/ShowSolarContract";
import ShowSolution from "./Pages/Solutions/ShowSolution";
import Messages from "./Pages/Messages/Messages";
import AllMessagesContainer from "./Pages/Messages/AllMessagesContainer";
import NoChats from "./Pages/Messages/NoChats";
import AllSunlightRates from "./Pages/SunlightRates/AllSunlightRates";
import SunlightRates from "./Pages/SunlightRates/SunlightRates";
import CreateSunlightRates from "./Pages/SunlightRates/CreateSunlightRates";
import Pusher from "pusher-js";
import Echo from "laravel-echo";
import { useEffect } from "react";
import { pusherData } from "./Redux/PusherSlice/PusherSlice";
import DesktopNotification from "./Layouts/DesktopNotification";
import "./Layouts/style.css";
import ApcAdder from "./Pages/ApcAdder/ApcAdder";
import AllApcAdder from "./Pages/ApcAdder/AllApcAdder";
import CreateAPCAdder from "./Pages/ApcAdder/CreateAPCAdder";
import InstallerShow from "./Pages/Installer/InstallerShow";
import InstallerAdders from "./Pages/Installer/Information/InstallerAdders";
import InstallerDocs from "./Pages/Installer/Information/InstallerDocs";
import CreateInstallerLicense from "./Pages/Installer/Information/License/CreateInstallerLicense";
import InstallerLicense from "./Pages/Installer/Information/License/InstallerLicense";
import EditInstallerLicense from "./Pages/Installer/Information/License/EditInstallerLicense";
import EditInstaller from "./Pages/Installer/EditInstaller";
import { CheckUserAuthorized } from "./Redux/UserSlice/UserSlice";
import Tickets from "./Pages/Tickets/Tickets";
import AllTickets from "./Pages/Tickets/AllTickets";
import ShowTicket from "./Pages/Tickets/ShowTicket";

function App() {
    //get the user
    const { mainUser } = useSelector((state) => state.auth);
    const { check } = useSelector((state) => state.users);
    const check_code = check?.response?.status;
    const user_id = mainUser?.data?.id;
    //create the theme
    const [theme, setTheme] = useLocalStorage("theme" ? "dark" : "light");

    const switchTheme = () => {
        const newThem = theme === "light" ? "dark" : "light";
        setTheme(newThem);
    };

    // Pusher.logToConsole = true;

    // const pusher = new Pusher("2c551729f5c7d105fc99", {
    //     cluster: "eu",
    // });
    // pusher.allChannels().forEach((channel) => console.log(channel.name));
    // const location = useLocation();
    // console.log(location)
    window.Pusher = Pusher;

    window.Pusher = new Echo({
        broadcaster: "pusher",
        key: "2c551729f5c7d105fc99",
        cluster: "eu",
        disableStats: true,
        encrypted: true,
    });
    const GetPusherLinkSRC = (chat) => {
        let department_id =
            chat?.user_sender?.role_id || chat?.user_receiver?.role_id;

        let site = chat?.user_sender?.site || chat?.user_receiver?.site;

        let user_id = chat?.user_sender?.id || chat?.user_receiver?.id;

        let name = chat?.user_sender?.name || chat?.user_receiver?.name;

        return `${department_id}/${site}/${user_id}/${name}`;
    };

    useEffect(() => {
        window.Pusher.channel("my-channel").listen(
            `.my-event-crm-${user_id}`,
            (data) => {
                let PusherData = data?.data;
                let link = GetPusherLinkSRC(PusherData);

                let name = PusherData.user_receiver
                    ? PusherData.user_receiver?.name
                    : PusherData.user_sender?.name;

                let department = PusherData.user_receiver
                    ? PusherData.user_receiver?.site
                    : PusherData.user_sender?.site;

                DesktopNotification(name, department, PusherData.body, link);
                dispatch(pusherData(data));
            }
        );
        // window.Pusher.join(`my-channel`)
        //     .here((users) => {
        //         alert(users);
        //     })
        //     .here((users) => {
        //         alert("This User Is Online Now", users);
        //     })
        //     .joining((user) => {
        //         alert("This User Is Joining Now", user);
        //     })
        //     .leaving((user) => {
        //         alert("This User Is Leaving Now", user);
        //     })
        //     .error((error) => {
        //         console.error(error);
        //     });

        // pusher.connection.bind("error", function (error) {
        //     if (error?.error?.data?.code === 4004) {
        //         alert("Pusher Connection Over limit!");
        //     }
        // });

        // const channel = pusher.subscribe("my-channel");

        // channel.bind(`my-event-crm-${user_id}`, function (data) {
        //     dispatch(pusherData(data));
        // });
    }, []);

    const dispatch = useDispatch();

    useEffect(() => {
        const CheckMemberAuthantization = async () => {
            await dispatch(CheckUserAuthorized());
        };
        if (window.location.pathname !== "/") {
            CheckMemberAuthantization();
        }
    }, []);

    useEffect(() => {
        if (check_code === 401) {
            localStorage.removeItem("user");
            window.location.href = window.location.origin;
        }
    }, [check_code]);

    return (
        <AppTheme data-theme={theme}>
            <GlobalStyle />
            <ToastContainer />
            <Routes>
                {!mainUser ? (
                    <>
                        <Route path="/" element={<Login />} />
                        <Route path="/*" element={<NotFound />} />
                        <Route
                            path="/dashboard/app"
                            element={<Navigate to="/" />}
                        />
                    </>
                ) : (
                    <>
                        <Route
                            path="/"
                            element={<Navigate to="/dashboard/app" />}
                        />
                        <Route
                            path="/dashboard/"
                            element={
                                <Dashboard
                                    switchTheme={switchTheme}
                                    mainUser={mainUser}
                                />
                            }
                        >
                            <Route
                                path="app"
                                element={
                                    <Analysis
                                        dispatch={dispatch}
                                        mainUser={mainUser}
                                    />
                                }
                            />
                            <Route path="users" element={<Users />}>
                                <Route index element={<AllUsers />} />
                                <Route
                                    path=":parent/childrens"
                                    element={<AllUsers />}
                                />
                                <Route
                                    path="edit=:id"
                                    element={<EditUsers />}
                                />
                            </Route>
                            <Route path="panels" element={<Panels />}>
                                <Route index element={<PanelsDataGrid />} />
                                <Route
                                    path="edit=:id"
                                    element={<EditPanel />}
                                />
                            </Route>
                            <Route
                                path="utility"
                                element={<UtilityProviders />}
                            >
                                <Route index element={<AllUtility />} />
                                <Route
                                    path="edit=:id"
                                    element={<EditUtility />}
                                />
                            </Route>
                            <Route path="leads" element={<Leads />}>
                                <Route index element={<AllLeads />} />
                                <Route path="edit=:id" element={<EditLead />} />
                                <Route
                                    path="user=:user_id"
                                    element={<AllLeads />}
                                />
                                <Route path=":id" element={<LeadInfo />} />
                            </Route>
                            <Route path="installer" element={<Installers />}>
                                <Route index element={<AllInstallers />} />
                                <Route
                                    path="edit=:installer_id"
                                    element={<EditInstaller />}
                                ></Route>
                                <Route
                                    path=":installer_id"
                                    element={<InstallerShow />}
                                >
                                    <Route
                                        path="adders"
                                        element={<InstallerAdders />}
                                    />
                                    <Route path="license">
                                        <Route
                                            index
                                            element={<InstallerLicense />}
                                        ></Route>
                                        <Route
                                            path="create"
                                            element={<CreateInstallerLicense />}
                                        ></Route>
                                        <Route
                                            path="edit=:license_id"
                                            element={<EditInstallerLicense />}
                                        ></Route>
                                    </Route>
                                    <Route
                                        path="docs"
                                        element={<InstallerDocs />}
                                    ></Route>
                                </Route>
                                <Route
                                    path="create"
                                    element={<CreateInstaller />}
                                ></Route>
                                <Route
                                    path=":id"
                                    element={<SingleInstaler />}
                                />
                            </Route>
                            <Route path="business" element={<Business />}>
                                <Route index element={<AllBusiness />} />
                            </Route>
                            <Route
                                path="solar-contracts"
                                element={<SolarContract />}
                            >
                                <Route
                                    index
                                    element={<AllSolarContracts />}
                                ></Route>
                                <Route
                                    path="user=:user_id"
                                    element={<AllSolarContracts />}
                                ></Route>
                                <Route
                                    path="lead=:lead_id"
                                    element={<AllSolarContracts />}
                                ></Route>
                                <Route
                                    path="show=:contract_is"
                                    element={<ShowSolarContract />}
                                ></Route>
                            </Route>
                            <Route path="vendors" element={<Vendors />}>
                                <Route index element={<AllVendors />} />
                                <Route
                                    index
                                    path="create"
                                    element={<CreateVendor />}
                                ></Route>
                                <Route
                                    index
                                    path="edit=:id"
                                    element={<EditVendor />}
                                ></Route>
                            </Route>
                            <Route path="contractors" element={<Contractors />}>
                                <Route index element={<AllContractors />} />
                                <Route
                                    index
                                    path="create"
                                    element={<CreateContractor />}
                                ></Route>
                                <Route
                                    index
                                    path="edit=:id"
                                    element={<EditContractor />}
                                ></Route>
                            </Route>
                            <Route path="designers" element={<Designers />}>
                                <Route index element={<AllDesigners />} />
                                <Route
                                    index
                                    path="create"
                                    element={<CreateDesigner />}
                                ></Route>
                                <Route
                                    index
                                    path="edit=:id"
                                    element={<EditDesigner />}
                                ></Route>
                                <Route
                                    index
                                    path="create/license"
                                    element={<CreateLicense />}
                                ></Route>
                                <Route
                                    path="licens"
                                    element={<AllLicense />}
                                ></Route>
                            </Route>
                            <Route path="solutions" element={<Solutions />}>
                                <Route index element={<AllSolution />}></Route>
                                <Route
                                    path="user=:user_id"
                                    element={<AllSolution />}
                                ></Route>
                                <Route
                                    path="lead=:lead_id"
                                    element={<AllSolution />}
                                ></Route>
                                <Route
                                    path="show=:id"
                                    element={<ShowSolution />}
                                >
                                    {" "}
                                </Route>
                            </Route>
                            <Route
                                exact
                                path="eversign-documents"
                                element={<EverSignDocuments />}
                            >
                                <Route
                                    exact
                                    index
                                    element={<AllDocuments />}
                                ></Route>
                                <Route
                                    exact
                                    path="signed=:is_completed"
                                    element={<AllDocuments />}
                                >
                                    {" "}
                                </Route>
                            </Route>
                            <Route path="adders" element={<Adders />}>
                                <Route index element={<AllAdders />}></Route>
                                <Route
                                    path="create"
                                    element={<CreateAdder />}
                                ></Route>
                                <Route
                                    path="edit=:id"
                                    element={<EditAdder />}
                                ></Route>
                            </Route>
                            <Route path="adders-categories" element={<AddersCategories />}>
                                <Route index element={<AllAddersCategories />}></Route>
                                <Route
                                    path="create-group"
                                    element={<CreateAdderCategory />}
                                ></Route>
                                <Route
                                    path="edit-group=:id"
                                    element={<EditAdderCategory />}
                                ></Route>
                                <Route
                                    path=":group_id"
                                    element={<EditAdderCategory />}
                                ></Route>
                                <Route
                                    path="group_childrens/:group_id"
                                    element={<GroupChildrens />}
                                ></Route>
                            </Route>
                            <Route path="adders/v2" element={<Addersv2 />}>
                                <Route index element={<AllAddersv2 />}></Route>
                                <Route
                                    path="create"
                                    element={<CreateAdderv2 />}
                                ></Route>
                                <Route
                                    path="edit=:id"
                                    element={<EditAdderv2 />}
                                ></Route>
                                <Route
                                    path="add-child=:parent_id"
                                    element={<CreateAdderv2Child />}
                                ></Route>
                                <Route
                                    path="parent=:parent_id"
                                    element={<AllAddersv2Childs />}
                                ></Route>
                            </Route>
                            <Route
                                path="sunlight-rates"
                                element={<SunlightRates />}
                            >
                                <Route
                                    index
                                    element={<AllSunlightRates />}
                                ></Route>
                                <Route
                                    path="create"
                                    element={<CreateSunlightRates />}
                                ></Route>
                            </Route>
                            <Route path="mails" element={<SendMail />}>
                                <Route index element={<CreateMail />} />
                            </Route>
                            <Route path="apc-adders" element={<ApcAdder />}>
                                <Route index element={<AllApcAdder />}></Route>
                                <Route
                                    path="create"
                                    element={<CreateAPCAdder />}
                                ></Route>
                            </Route>
                            
                            <Route path="tickets" element={<Tickets />}>
                                <Route index element={<AllTickets />}></Route>
                                <Route path="show/:ticket_id" element={<ShowTicket />}></Route>
                            </Route>
                        </Route>
                        <Route
                            path="messages"
                            element={
                                <Messages
                                    mainUser={mainUser}
                                    switchTheme={switchTheme}
                                />
                            }
                        >
                            <Route index element={<NoChats />}></Route>
                            <Route
                                path=":department_id_receiver/:site_receiver/:user_receiver/:user_name"
                                element={<AllMessagesContainer />}
                            ></Route>
                        </Route>
                    </>
                )}

                {/* <Route path="/" element={<Login />} />
        <Route path="/*" element={<NotFound />} />
        <Route path="/dashboard/" element={<Dashboard />}>
          <Route path="app" element={<Analysis />} />
          <Route path="users" element={<Analysis />} />
        </Route> */}
            </Routes>
        </AppTheme>
    );
}

const AppTheme = styled.div`
    background: var(--body-color);
    transition: all 0.3s ease-in-out;
    min-height: 100vh;
`;
export default App;
